import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import WPButton from "../../packages/WPButton";

import { ReadIcon } from "../../assets/icons";

import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import "./index.scss";

const RevisitTour = ({
  onClick,
  showtooltipAfterTour = false,
  tooltipText = "",
  tooltipDuration = 5000,
}) => {
  const { t } = useTranslation();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [tooltipContent, setTooltipContent] = useState(null);
  const tooltipTimerRef = useRef(null);

  const clearTooltipTimer = () => {
    if (tooltipTimerRef.current) {
      clearTimeout(tooltipTimerRef.current);
      tooltipTimerRef.current = null;
    }
  };

  useEffect(() => {
    clearTooltipTimer();

    if (!showtooltipAfterTour) {
      setIsTooltipVisible(false);
      return;
    }

    setIsTooltipVisible(true);
    tooltipTimerRef.current = setTimeout(() => {
      setIsTooltipVisible(false);
      tooltipTimerRef.current = null;
    }, tooltipDuration);

    return () => {
      clearTooltipTimer();
    };
  }, [showtooltipAfterTour, tooltipDuration]);

  const handleStartTour = () => {
    if (!isTooltipVisible) {
      onClick?.();
    }
  };

  const handleOkayClick = () => {
    setIsTooltipVisible(false);
    clearTooltipTimer();
  };

  const revisitTooltipContent = (
    <div className="revisit-tour__tooltip-content" role="status">
      <div className="revisit-tour__post-tour-text">
        {t("featureTour.revisitTourFromHere")}
      </div>
      <WPButton
        variant="text"
        onClick={handleOkayClick}
        customClass="revisit-tour__okay-button"
      >
        {t("ValueStrings.okay")}
      </WPButton>
    </div>
  );

  useEffect(() => {
    if (isTooltipVisible) {
      setTooltipContent(revisitTooltipContent);
    } else {
      setTooltipContent(null);
      setTimeout(() => {
        setTooltipContent(tooltipText || t("featureTour.startTour"));
      }, 300);
    }
  }, [isTooltipVisible]);

  return (
    <CustomTooltip
      text={tooltipContent}
      placement="bottom"
      forceShow={isTooltipVisible}
      className="revisit-tour__custom-tooltip"
    >
      <ReadIcon
        width={24}
        height={24}
        onClick={handleStartTour}
        className="revisit-tour__icon"
      />
    </CustomTooltip>
  );
};

export default RevisitTour;
